import React, { Component } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { Icon } from '@iconify/react';
import facebookRect from '@iconify/icons-brandico/facebook-rect';
import Footer from './Footer'
import HeaderTop from './HeaderTop'
import SideNavTop from './SideNavTop'
import '../Accueil.css'

class CAPN extends Component {
state = {
    redirect:false,
    search: ''
    }

handleCHange = event => {
    const { name, value } = event.target
    this.setState({ [name]: value })
}

setRedirect = () => {
    this.setState({
      redirect: true
    })
  }
  
  handleSubmitFacebbok = () => {
    if (this.state.redirect) {
        window.location.href = "https://www.facebook.com/clubCAPN/";
    }
  }

handleSubmit = event => {
    //on gere le form
    event.preventDefault()
    this.props.history.push(`/recherche/${this.state.search}`);
}

render () {  
    return (
    <>
        <Container fluid>
        <Row>
            <SideNavTop/>
            <Col lg={10} md={12} sm={12} xs={12} id="page-content-wrapper" className="nopadding">
              <HeaderTop
                handleSubmit={this.handleSubmit}
                handleCHange={this.handleCHange}
                handleSubmitFacebbok={this.handleSubmitFacebbok}
                setRedirect={this.setRedirect}
              />

                <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                    <Row>
                    <Col lg={12} md={12} sm={12} xs={12} className="nopadding">

                    <p className="pCenter pageFull">Le C.A.P.N est l'acronyme pour Le Club Aquatique les Piranhas du Nord.<br/><br/>
                    Vous pouvez consulter notre page Facebook <Icon icon={facebookRect} /></p>
                    </Col>

                    <Col lg={{  offset: 3, span: 6 }} md={{  offset: 3, span: 6 }} sm={12} xs={12} >


                        <ul class="links two-links">
                            <li><a href="/CAPN/emploi">Emploi</a></li>

                            <li><a href="/CAPN/histoire">Qu'est ce que le CAPN</a></li>

                            <li><a href="/CAPN/conseil-administration">Conseil Administration</a></li>

                            <li><a href="/CAPN/politiques">Politiques du C.A.P.N</a></li>

                            <li><a href="/CAPN/informations">Informations générales</a></li>

                        </ul>
                    </Col>
                    </Row>
                </Col>


            <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                <div className="fixed-bottom-footer"><Footer /></div>
            </Col>
            </Col>
        </Row>
        </Container>
    </>
    )
}
}

export default CAPN
